import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { adminIconBadgeSx } from "./adminStyles";

// One consistent header for every admin section. The pages previously each
// rolled their own — one used h4 + body2 with no icon badge, the rest used an
// icon badge + h5 + caption, and the destructive page used a red badge — so the
// tabs read as five different apps. This normalises the icon badge, title, and
// subtitle, and exposes an `actions` slot on the right (window toggle, run
// button, etc.). Title/subtitle text and any testids stay owned by the caller.
export default function AdminPageHeader({
  icon,
  iconAccent,
  title,
  subtitle,
  actions,
}) {
  const theme = useTheme();
  const accent = iconAccent || theme.palette.primary.light;
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 2,
        mb: 3,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, minWidth: 0 }}>
        {icon ? <Box sx={adminIconBadgeSx(accent)}>{icon}</Box> : null}
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="h5" sx={{ fontWeight: 700, lineHeight: 1.25 }}>
            {title}
          </Typography>
          {subtitle ? (
            <Typography
              variant="caption"
              component="p"
              sx={{ color: theme.palette.text.secondary, mt: 0.25 }}
            >
              {subtitle}
            </Typography>
          ) : null}
        </Box>
      </Box>
      {actions ? (
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexShrink: 0 }}>
          {actions}
        </Box>
      ) : null}
    </Box>
  );
}
